import { Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { RouterConstants } from './core/routing/constants/app-paths.constant';
import { DetailService } from './core/routing/services/details/detail.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { Subscription } from 'rxjs/internal/Subscription';
import { GlobalConstants } from './common/constants/global.constant';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { AppGlobal } from './core/state/app-global';
import { User } from './modules/account/login/_models/user.model';
import { CommonService } from './common/services/common.service';
import { WebsocketService } from './core/routing/services/websocket/websocket.service';
import { Utils } from './common/utils/utils';
import { environment } from './../environments/environment';
import { RetailService } from './core/routing/services/retail_api/retail.service';
import { RetailHqConfiguration } from './modules/users/interface/retail.i';

declare let gtag: Function;

@Component({
  selector: 'iposcen-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'ipos-ui-central';
  assetLibraryHref: string;
  homePageHref: string;
  mainLayout: boolean;
  currentdetailPage: string;
  globalconst = GlobalConstants;
  profileHref: string;
  storesHref: string;
  homePageTabIndex: number;
  layOut: boolean;
  downloadIPOS: string;
  activeUsersHref: string;
  deviceDashboardHref: string;
  myAccountHref: string;
  helpHref: string;
  isNonConnectedUser: boolean;
  isAdmin: boolean;
  userInfo: User;
  changeLanguage: string;
  direction: string;
  isWebsocketConn: boolean;
  setNavZIndex: boolean = false;
  gaPropertyId = environment.gaPropertyId;
  standardDownload = RouterConstants.STANDARD_DOWNLOAD;
  userRole: string = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  isUserAuthor: boolean = false;
  isRegionalHQ: boolean = false;
  isSrtAdmin = false;
  reviewPartnerContentHref: string;
  hidePartnerContent: boolean = environment.hidePartnerContent;
  regionalData: any;
  regionalRetailerIDdata: any;
  selectedRegionalData: any;
  showPopupdata: string;
  regionalDisplay = [];
  regionalRetailerIDs = [];
  regionalPopUpMapIds = {};
  retailIdData = [];
  showprofilePopup = false;
  yes = GlobalConstants.YESS;
  no = GlobalConstants.NOT;
  switchContentGroup: boolean;
  configurations: RetailHqConfiguration;
  hideSecondNav: boolean;
  skuIdsHref: string;
  retailerNameData = [];
  gameDemo: boolean = false;
  gameDemoPage: boolean;
  isArabic = localStorage.getItem('preferredLanguage') === 'ar-sa';
  isHebrew = localStorage.getItem('preferredLanguage') === 'he';
  changePlacement: boolean = false;
  env = environment.apiBaseUrl;
  srtKiosk: string;
  allRetailerData = [];
  userId = sessionStorage.getItem('userId');
  private ngUnsubscribe = new Subject<boolean>();
  private routerdetailPage: Subscription;
  deviceExecutiveRole: boolean;
  isCollapsed = false;

  constructor(
    private router: Router,
    private detailService: DetailService,
    private ref: ChangeDetectorRef,
    private gtmService: GoogleTagManagerService,
    private appGlobal: AppGlobal,
    private cmnService: CommonService,
    private webSocketConn: WebsocketService,
    private retailHqService: RetailService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', this.gaPropertyId,
          {
            'page_path ': event.urlAfterRedirects,
            'custom_map': {
              'new_model_sku_info_added': 'new_model_SKU_info_added',
              'download_standard_ipos': 'download_standard_IPOS',
              'create_new_profile_succesful': 'Creation new profile successful',
              'store_logo_added': 'Store logo added',
              'push_update_devices': 'push_update_device',
              'add_new_retailer_hq': 'add_new_retailer_hq',
              'add_new_store': 'add_new_store',
              'approve_pending_user': 'approve_pending_user',
              'attract_loop_video_selected': 'attract_loop_video_selected',
              'batch_new_stores_added': 'batch_new_stores_added',
              'push_update_logo': 'push_update_logo',
              'push_update_idle_experience': 'push_update_idle',
              'push_update_custom_button': 'push_update_button',
              'new_active_user_added': 'new_active_user_added',
              'new_domain_added_to_whitelist': 'new_domain_added_to_whitelist',
              'reject_pending_user': 'reject_pending_user',
              'push_update_multiple_device': 'push_update_multiple_device',
              'push_update_single_device': 'push_update_single_device',
              'update_via_csv': 'update_via_csv',
              'new_author_added': 'new_author_added',
              'new_content_group_added': 'new_content_group_created',
              'new_partner_added': 'new_partner_added',
              'download_linux_ipos': 'download_linux_IPOS',
              'download_gaming_ipos': 'download_gaming_IPOS',
              'reset_password_successful': GlobalConstants.RESET_PWD_SUCCESS,
              'download_chromebook_ipos': 'download_chromebook_IPOS',
              'download_creator_ipos': 'download_creator_IPOS',
              'download_full_report': 'Download full report',
              'sku_csv_upload': 'SKU CSV upload',
              'account_transfer': 'Account transfer',
              'profile_increase_prom_rotation': 'Idle experience option',
              'idle_experience_option': 'idle_experience_option',
              'increase_promo_rotation': 'Increased promo rotation',
              'hq_acc_assigned_to_reg_user_changed': 'HQ account assigned to regional user',
              'custom_main_tile_flag_enabled': 'Custom main tile flag enabled',
              'custom_main_tile_content_group_added': 'Custom main tile content group added to the package',
              'sku_content_added_in_package': 'SKU Content added in package',
              'store_deleted_by_retailhq': 'Store deleted by RetailHQ',
              'store_deleted_by_admin': 'Store deleted by Admin',
              'account_language': 'Account language',
              'user_role': 'User role',
              'retailer_name': 'Retailer name',
              'retailer_id': 'Retailer id',
              'device_type': 'Device type',
              'device_info_tab_name': 'Device_info_tab_name',
              'user_id': 'User id',
              'device_info_changes': 'Device_info_changes_saved',
              'package_type': 'package_type',
              'download_ipos': 'Package type created',
              'os_type': 'OS type',
              'push_password_changes': GlobalConstants.PUSH_PASSWORD_CHANGES,
              'enabled_4k_video': '4k video enabled',
              'game_included_to_the_package': 'Game included to the package',
              'download_package_tracking': 'Download package tracking'
            }
          },
        );
      }
    }
    );
  }

  ngOnInit(): void {
    this.gtmService.addGtmToDom();
    this.assetLibraryHref = RouterConstants.ASSET_LIBRARY_LINK;
    this.homePageHref = RouterConstants.HOME_PAGE_LINK;
    this.profileHref = RouterConstants.PROFILES_LINK;
    this.storesHref = RouterConstants.STORES_LINK;
    this.downloadIPOS = GlobalConstants.DOWNLOAD_LIBRARY_IPOS;
    this.srtKiosk = GlobalConstants.SRT_KIOSK;
    this.activeUsersHref = RouterConstants.ACTIVE_USERS_LINK;
    this.myAccountHref = RouterConstants.MY_ACCOUNT_LINK;
    this.helpHref = RouterConstants.HELP_LINK;
    this.deviceDashboardHref = RouterConstants.DEVICE_DASHBOARD_LINK;
    this.changeLanguage = RouterConstants.CHANGE_LANGUAGE_LINK;
    this.reviewPartnerContentHref = RouterConstants.REVIEW_PARTNERS_LINK;
    this.skuIdsHref = RouterConstants.SKU_IDS_LINK;
    this.homePageTabIndex = 0;
    this.getAllUserDetails();
    if (this.userRole === 'regionalHQ' || this.userRole === GlobalConstants.SRT_ADMIN) {
      if (this.checkRetailerIdIsMultiple()) this.cmnService.setRetailerListPopupFlag(true); else this.cmnService.setRetailerListPopupFlag(false);
    }
    if (sessionStorage.getItem('user')) {
      const obj = JSON.parse(sessionStorage.getItem('user')) as User;
      this.cmnService.displayRegionalDetails(obj);
    }

    this.cmnService.getRetailerListPopupFlag
      .subscribe(response => {
        if (!response && !this.checkRetailerIdIsMultiple()) {
          this.setRetailerIDsForRegionalHQ();
        }
      });
    this.cmnService.getRegionalUserDetails
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.regionalData = data;
        let UnSortedObj = {};
        if (this.regionalData) {
          if (this.regionalData.role === 'regionalHQ' || this.regionalData.role === GlobalConstants.SRT_ADMIN) {
            let retailerNames = this.regionalData['retailerName'].split(",");
            let retailerIds = this.regionalData['retailerID'].split(",");
            retailerNames.forEach((e, i) => {
              UnSortedObj[e] = retailerIds[i]
            });
            this.getMappedRetailerPopup(UnSortedObj);
          }
        }
      });
    this.cmnService.getRegionalRetailerIds
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.regionalRetailerIDdata = data;
      });
    // }
    // TODO:Added below code for time being, need to replace with proper structure, same for line number 170
    if (sessionStorage.getItem('user')) {
      const obj = JSON.parse(sessionStorage.getItem('user')) as User;
      this.appGlobal.setCurrentUser(obj);
    }

    this.detailService.$isMainLayout
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => (this.mainLayout = message));
    // if (this.mainLayout) {
    //   console.log(this.mainLayout);
    //   this.router.navigateByUrl(RouterConstants.HOME_PAGE_LINK);
    // } else {
    //   this.router.navigateByUrl('');
    // }
    // this.webSocketConn.connectWebSocket()
    //   .subscribe(
    //     msg => {
    //       if (msg) {
    //         // listen the response from server and update the status
    //         const profileRecords = msg.profile;
    //         this.webSocketConn.triggerProfileDashboard.next(msg);
    //       }
    //     },
    //     err => {
    //       // TODO check for error code
    //       this.webSocketConn.connectWebSocket();
    //       this.webSocketConn.send();
    //       Utils.handleError(err, this.constructor.name);
    //     },
    //     () => {
    //       this.webSocketConn.connectWebSocket();
    //       this.webSocketConn.send();
    //     }
    //   );
    this.isWebsocketConn = false;
    this.cmnService.setNavZIndexObser.subscribe(res => {
      this.setNavZIndex = res.setZIndex;
    });

    if (this.userRole === "author") {
      this.isUserAuthor = true;
      this.layOut = false;
    }
    this.cmnService.retailPageObserver
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        this.hideSecondNav = resp;
      });
    if (this.isArabic || this.isHebrew) {
      this.changePlacement = true;
    }
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  setIndex(value: number) {
    this.homePageTabIndex = value;
    this.cmnService.setCreateRetailPage(false);
  }
  ngAfterViewInit() {
    // return to home page from details page and click on view all specs, header should not be selected
    this.routerdetailPage = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentdetailPage = event.urlAfterRedirects;
        const pageName = this.currentdetailPage.lastIndexOf('/');
        const routes = [GlobalConstants.GAME_DEMOS, GlobalConstants.UNISON_DEMO, GlobalConstants.HOME_PAGE, GlobalConstants.STORE_PAGE, GlobalConstants.ASSET_LIBRARY, GlobalConstants.PROFILE_PAGE, GlobalConstants.PROFILE_UPDATEIPOS, GlobalConstants.CREATE_PROFILE, GlobalConstants.USERS_RETAILHQS, GlobalConstants.USERS_STORES, GlobalConstants.USERS_ACTIVEUSERS, GlobalConstants.USERS_DOMAINWHITELIST, GlobalConstants.DEVICE_DASHBOARD, GlobalConstants.ACTIVE_DEVICE_REPORT, GlobalConstants.DEVICE_STORE_LOGO, GlobalConstants.DEVICE_SETTINGS, GlobalConstants.USERS_PENDINGUSERS, GlobalConstants.MY_ACCOUNT, GlobalConstants.CHANGE_LANGUAGE, GlobalConstants.HELP, GlobalConstants.STANDARD_DOWNLAOD, GlobalConstants.REVIEW_PARTNER_CONTENT, GlobalConstants.APPROVED_PARTNER_CONTENT, GlobalConstants.PARTNERS, GlobalConstants.AUTHORS, GlobalConstants.SKU_IDS, GlobalConstants.OEM_SYSTEM_IDS];
        this.gameDemoPage = this.currentdetailPage.substring(pageName + 1) === GlobalConstants.GAME_DEMOS ? true : false;
        if (this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE) || routes.indexOf(this.currentdetailPage.substring(pageName + 1)) >= 0) {
          this.layOut = false;
          // if (!this.isWebsocketConn) {
          //   this.webSocketConn.send();
          //   this.isWebsocketConn = true;
          // }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.HOME_PAGE) {
            this.homePageTabIndex = 0;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.ASSET_LIBRARY) {
            this.homePageTabIndex = 3;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.PROFILE_PAGE || this.currentdetailPage.substring(pageName + 1) === GlobalConstants.PROFILE_UPDATEIPOS ||
            this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE) || this.currentdetailPage.includes(RouterConstants.CREATE_PROFILE_LINK)) {
            this.homePageTabIndex = 2;
          }
          if (this.currentdetailPage.includes('/users/')) {
            this.homePageTabIndex = 1;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.STANDARD_DOWNLAOD) {
            this.homePageTabIndex = 4;
          }
          if (this.currentdetailPage.includes('/devices/')) {
            this.homePageTabIndex = 5;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.MY_ACCOUNT) {
            this.homePageTabIndex = 6;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.CHANGE_LANGUAGE) {
            this.homePageTabIndex = 7;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.HELP) {
            this.homePageTabIndex = 8;
          }
          if (this.currentdetailPage.includes('/partner-content/')) {
            this.homePageTabIndex = 9;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.SKU_IDS) {
            this.homePageTabIndex = 10;
          }
          if (this.currentdetailPage.substring(pageName + 1) === GlobalConstants.GAME_DEMOS ||
            this.currentdetailPage.substring(pageName + 1) === GlobalConstants.UNISON_DEMO)
            this.gameDemo = true;
        } else {
          this.layOut = true;
        }
        if (this.currentdetailPage.includes(GlobalConstants.OEM) ||
          this.currentdetailPage.substring(pageName + 1) === GlobalConstants.GAME_DEMOS ||
          this.currentdetailPage.substring(pageName + 1) === GlobalConstants.UNISON_DEMO) {
          this.layOut = false;
          this.isUserAuthor = true;
        }
      }
    });
    this.ref.detectChanges();
  }

  setFont() {
    let language = localStorage.getItem('preferredLanguage');
    this.direction = (language === "ar-sa" || language === "he") ? "rtl" : "ltr";
    this.cmnService.direction = this.direction;

    switch (language) {
      case "ar-sa":
        return 'arabic-font';
      case "zh-Hans":
        return 'zh-hans-font';
      case "zh-Hant":
        return 'zh-hant-font';
      case "el":
        return 'greek-font';
      case "he":
        return 'hebrew-font';
      case "ja":
        return 'japanese-font';
      case "ko":
        return 'korean-font';
      case "ru":
        return 'cyrillic-font';
      case "uk":
        return 'cyrillic-font';
      case "th":
        return 'thai-font';
      case "vi":
        return 'vietnamese-font';
      default:
        return 'default-font';
    }
  }

  checkRetailerIdIsMultiple() {
    if (sessionStorage?.getItem('retailerId') !== undefined) {
      const retailerID = sessionStorage?.getItem('retailerId');
      var isRetailerIDMultiple = (retailerID?.indexOf(',') > -1) ? true : false;
    }
    return isRetailerIDMultiple;
  }

  setRetailerIDsForRegionalHQ() {
    this.cmnService.getSelectedRegionalUserDetails
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        if (data) {
          this.selectedRegionalData = data;
        } else if ((data === '') && (this.userRole === GlobalConstants.REGIONALHQ || this.userRole === GlobalConstants.SRT_ADMIN)) {
          this.selectedRegionalData = sessionStorage.getItem('retailerName');
          this.selectedRegionalData = this.selectedRegionalData.split(",")[0];
          this.cmnService.selectedRegionalRetailerName = this.selectedRegionalData;
        }
      });
  }

  getAllUserDetails() {
    // Get the existing user object
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        // if(typeof this.userInfo.userId === 'undefined'){
        //   this.userInfo.email =  sessionStorage.email ;
        //   this.userInfo.firstName =  sessionStorage.firstName ;
        //   this.userInfo.lastName =  sessionStorage.lastName ;
        //   this.userInfo.location =  sessionStorage.location ;
        //   this.userInfo.retailerID =  sessionStorage.retailerID ;
        //   this.userInfo.retailerName =  sessionStorage.retailerName ;
        //   this.userInfo.role =  sessionStorage.userRole;
        //   this.userInfo.userId =  sessionStorage.userId ;
        //   sessionStorage.setItem('user', JSON.stringify(this.userInfo));
        // }        
        this.isNonConnectedUser = this.userInfo.role === GlobalConstants.NON_CONNECTED_USER ? true : false;
        this.isSrtAdmin = this.userInfo.role === GlobalConstants.SRT_ADMIN ? true : false;
        this.isAdmin = this.userInfo.role === GlobalConstants.INTEL_ADMIN ? true : false;
        this.isRegionalHQ = this.userInfo.role === GlobalConstants.REGIONALHQ ? true : false;
        this.deviceExecutiveRole = this.userInfo.role === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE ? true : false;
      });
  }
  // TODO:Added below code for time being, need to replace with proper structure
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    sessionStorage.setItem('user', JSON.stringify(this.userInfo));
  }

  setHomeNavActive() {
    if (this.deviceExecutiveRole) {
      this.router.navigateByUrl(RouterConstants.DEVICE_DASHBOARD_LINK);
    } else {
      if (!this.isSrtAdmin && !this.isUserAuthor) {
        this.homePageTabIndex = 0;
        this.router.navigateByUrl(RouterConstants.HOME_PAGE_LINK);
      } else {
        this.homePageTabIndex = 0;
        this.router.navigateByUrl(RouterConstants.OEM_HOME_LINK);
      }
      this.cmnService.setCreateRetailPage(false);
    }
  }


  redirectToHome() {
    if (this.gameDemoPage) {
      this.gameDemo = false;
      this.layOut = true;
      this.isUserAuthor = false;
      this.homePageTabIndex = 0;
      this.cmnService.setCreateRetailPage(false);
    }
  }

  redirectToLogin() {
    location.assign(RouterConstants.SLASH);
    sessionStorage.clear();
  }
  reloadCurrentPage() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.currentdetailPage]);
  }
  async selectRegionalList(data) {
    this.switchContentGroup = false;
    if (!(this.currentdetailPage.includes(RouterConstants.CREATE_PROFILE_LINK) || this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE))) {
      this.cmnService.setRetailGifValue(true);
    }
    this.cmnService.getSwitchstatus
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(resp => {
        if (resp === true) {
          this.switchContentGroup = true;
        }
      });
    this.regionalDisplay.forEach((e, i) => {
      this.regionalPopUpMapIds[e] = this.regionalRetailerIDs[i]
    });
    if (!(this.currentdetailPage.includes(RouterConstants.CREATE_PROFILE_LINK) || (this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE) || (this.switchContentGroup)))) {
      this.selectedRegionalData = data;
      await this.setRetailerInfo(this.selectedRegionalData);
    } else {
      this.showprofilePopup = true;
      this.showPopupdata = data;
    }
    if (!(this.currentdetailPage.includes(RouterConstants.CREATE_PROFILE_LINK) || (this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE) || (this.switchContentGroup))) && this.currentdetailPage !== RouterConstants.PROFILES_LINK) {
      this.reloadCurrentPage();
    }
    if (this.currentdetailPage === RouterConstants.PROFILES_LINK) {
      // this.cmnService.setProfileWebSocketData(true);
      this.cmnService.fetchProfileSub();
    }
  }

  async redirectToProfile() {
    this.showprofilePopup = false;
    this.selectedRegionalData = this.showPopupdata;
    await this.setRetailerInfo(this.selectedRegionalData);
    if (this.currentdetailPage.includes(RouterConstants.CREATE_PROFILE_LINK) || (this.currentdetailPage.includes(RouterConstants.EDIT_PROFILE))) {
      this.router.navigateByUrl(RouterConstants.PROFILES_LINK);
    }
    else if (this.currentdetailPage.includes(RouterConstants.ASSET_LIBRARY_LINK)) {
      this.reloadCurrentPage();
      this.cmnService.setSwitchstatus(false);
    }
  }

  setRetailerInfo(data: any) {
    return new Promise((resolve,reject)=>{
      sessionStorage.setItem('retailerId', this.regionalPopUpMapIds[data]);
      sessionStorage.setItem('retailerName', data);
      this.retailHqService.getAllRetailerInfoById(sessionStorage.getItem('retailerId'))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(getAllRetailHqResponse => {
          if (getAllRetailHqResponse) {
            this.configurations = JSON.parse(getAllRetailHqResponse.retailer.configurations) as RetailHqConfiguration;
            this.userInfo.configurations = getAllRetailHqResponse.retailer.configurations; //Saving Retail HQ user's configurations in app-global
            this.appGlobal.setCurrentUser(this.userInfo);
            resolve(this.userInfo);
          }
        }, error => {
        });
    })
  }

  closePopup() {
    this.showprofilePopup = false;
    this.switchContentGroup = false;
    this.cmnService.setSwitchstatus(false);
    this.cmnService.setRetailGifValue(false);
  }

  getMappedRetailerPopup(unSortedRetailerPopup) {
    this.regionalPopUpMapIds = Object.keys(unSortedRetailerPopup).sort().reduce(
      (acc, key) => ({ ...acc, [key]: unSortedRetailerPopup[key] })
      , {}
    );
    this.regionalDisplay = Object.keys(this.regionalPopUpMapIds);
    this.regionalRetailerIDs = Object.values(this.regionalPopUpMapIds);
  }
}
